import { FC, useCallback, useMemo } from "react"
import { Button, ButtonProps, LinkBaseProps, useTheme } from "@mui/material"
import { isFunction } from "lodash"

import { ShareIcon } from "components/icons"
import { useTranslation } from "providers/i18n"
import { getIcon } from "utils/icon"

interface IShareButtonProps extends ButtonProps, Pick<LinkBaseProps, "target"> {
  title?: string
  text?: string
  url?: string
  label?: string
}

export const ShareButton: FC<IShareButtonProps> = ({
  title,
  text,
  url,
  label = "Share",
  startIcon = <ShareIcon />,
  onClick,
  ...props
}) => {
  const theme = useTheme()
  const shareIcon = useMemo(
    () =>
      getIcon(theme?.assets?.shareStartButtonIcon) ||
      startIcon || <ShareIcon />,
    [theme, startIcon]
  )

  const { t } = useTranslation()
  const isSharebale = !!navigator.share
  const handleClick = useCallback(
    async (event) => {
      if (isFunction(onClick)) onClick(event)

      if (isSharebale) {
        try {
          await navigator.share({ title, text, url })
          alert("Share successful")
        } catch (err) {
          console.log("Error: ", err)
        }
      } else {
        console.log("Native Web Sharing not supported")
      }
    },
    [onClick, text, title, url, isSharebale]
  )

  return (
    isSharebale && (
      <Button
        variant="outlined"
        target="_top"
        rel="noopener noreferrer"
        startIcon={shareIcon}
        onClick={handleClick}
        {...props}
      >
        {t(label)}
      </Button>
    )
  )
}
